<template>
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="left-chevron-title"
  >
    <path
      d="M10.0607 0.43934C10.6464 1.02513 10.6464 1.97487 10.0607 2.56066L3.62132 9L10.0607 15.4393C10.6464 16.0251 10.6464 16.9749 10.0607 17.5607C9.47487 18.1464 8.52513 18.1464 7.93934 17.5607L0.439341 10.0607C-0.146446 9.47487 -0.146446 8.52513 0.439341 7.93934L7.93934 0.43934C8.52513 -0.146447 9.47487 -0.146447 10.0607 0.43934Z"
      fill="#4B4C52"
    />
    <title id="left-chevron-title">{{ title }}</title>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'CaretLeft',
  props: {
    title: {
      type: String,
      default: 'previous slide',
    },
  },
};
</script>
